import { defineComponent as _defineComponent } from 'vue'
import { useModal } from 'vue-nice-modal'
import { PropType, ref } from 'vue'
import { EnumModalOpStatus } from '@xt/client/enums/messageModalQueue'
import type { SatisfiedPopupProps } from '@xt/client/utils/messageModalQueue/types'
import LazyImg from '@xt/mobile/components/lazyImg/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  dataSource: {
    required: true,
    type: Object as PropType<SatisfiedPopupProps>
  }
},
  setup(__props) {

const props = __props;

const modal = useModal() // hook 在 wrapper 中使用


const innerData = ref(props.dataSource)

const onClose = () => {
  modal.resolve({
    status: EnumModalOpStatus.Close
  })
  modal.hide()
}

return { __sfc: true,modal, props, innerData, onClose, LazyImg }
}

})